/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

class RangeSlider extends Component {
	constructor(props) {
		super(props);

		this.step = props.step ? props.step : 1;
		this.min = props.min ? props.min : 0;
		this.max = props.max ? props.max : 100;
	}

	keyDown = e => {
		if (e.keyCode === 38) {
			e.preventDefault();
			this.props.onChange(parseInt(this.props.value, 10) + this.step);
		} else if (e.keyCode === 40) {
			e.preventDefault();
			this.props.onChange(parseInt(this.props.value, 10) - this.step);
		}
	};

	render() {
		const { value, placeholder, min, max, error, isRequired } = this.props;
		return (
			<div className="number-input">
				<div className={`input-wrap focus ${error}`}>
					<div className="placeholder caption-text">
						{isRequired && <span className="isrequired-label">*</span>}
						{placeholder}
					</div>
					<div className="number-input-item input-box">
						<input
							value={value}
							onChange={event => {
								this.props.onChange(event.target.value);
							}}
							onKeyDown={this.keyDown}
						/>
						<input
							type="range"
							value={value}
							onChange={event => {
								this.props.onChange(event.target.value);
							}}
							min={min ? min : 0}
							max={max ? max : 100}
						/>
					</div>
				</div>
			</div>
		);
	}
}

RangeSlider.propTypes = {
	placeholder: PropTypes.string,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	value: PropTypes.any,
	error: PropTypes.string,
	onChange: PropTypes.func,
	isRequired: PropTypes.isRequired,
};

export default RangeSlider;
